import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Are online casinos legal in the UK?',
      answer: 'Yes, online gambling is fully legal and regulated in the UK. All operators must hold a license from the UK Gambling Commission to offer services to British players. We only feature casinos that are properly licensed and regulated.'
    },
    {
      question: 'How do I know if a casino is safe?',
      answer: 'Look for the UK Gambling Commission license badge on the casino\'s website. Licensed operators must meet strict standards for security, fairness, and player protection. We also check for SSL encryption, responsible gambling tools, and positive player feedback before recommending any casino.'
    },
    {
      question: 'What are wagering requirements?',
      answer: 'Wagering requirements determine how many times you must bet your bonus amount before you can withdraw winnings. For example, if you receive a £100 bonus with 30x wagering, you\'ll need to place £3,000 in bets before cashing out. Always check these terms before claiming any bonus.'
    },
    {
      question: 'How long do withdrawals take?',
      answer: 'Withdrawal times vary by method and casino. E-wallets like PayPal and Skrill typically process within 24 hours, while debit cards can take 3-5 business days. Bank transfers may take up to 7 days. We prioritize casinos with fast payout times in our reviews.'
    },
    {
      question: 'Can I play for free?',
      answer: 'Many casinos offer demo modes for slots and table games, allowing you to play without risking real money. However, you cannot win real money in demo mode. Some casinos also offer no-deposit bonuses, but these usually come with strict wagering requirements.'
    },
    {
      question: 'What should I do if I have a problem with a casino?',
      answer: 'First, contact the casino\'s customer support directly. If that doesn\'t resolve the issue, you can file a complaint with the UK Gambling Commission or use alternative dispute resolution services like IBAS (Independent Betting Adjudication Service).'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-gray-900 to-dark-black">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-400">
              Everything you need to know about UK online casinos
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-gray-900/50 border border-gray-800 rounded-lg overflow-hidden hover:border-toxic-orange transition-colors"
              >
                <button
                  className="w-full px-6 py-5 flex items-center justify-between text-left"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-white font-semibold pr-4">
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`text-toxic-orange flex-shrink-0 transition-transform ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    size={24}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-300 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

